
import { defineComponent, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import useNotifications from '@/common/composable/useNotifications'

import { directions } from '@/core/realisations/directions.realisation'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'file-reader': FileReader,
        'the-button': TheButton,
    },
    setup() {
        const notifications = useNotifications()

        const state = reactive({
            file: [] as File[],
            is_loading: false,
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const reset = () => {
            state.file = []
            state_form$.value.$reset()
        }

        const importDirections = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('directions', state.file[0])

                await directions.importFromExcel(form_data)

                notifications.notify({
                    title: 'Направления импортированы!',
                    type: 'success',
                })

                reset()
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При импортировании направлений произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return { state, state_form$, importDirections }
    },
})
